import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
    namespaced: true,
    state() {
        return {

            proposals_list: [],
            current_proposal: null
            
        };
    },
    actions,
    mutations,
    getters,
};
